import Vue from 'vue';
import {LoggingMixin} from '@vanti/vue-logger';

Vue.mixin(LoggingMixin);
